import { toRole } from "@/lib/roles"
import type { FilterDef, FilterValue } from "@/lib/table"

import { ROLE_OPTIONS, type UserFilters } from "./users-keys-data"

export function buildUserFilterSchema(): FilterDef[] {
  return [
    {
      id: "role",
      label: "Role",
      kind: "select",
      options: ROLE_OPTIONS.map((r) => ({ value: r.value, label: r.label })),
      placeholder: "Any role",
    },
    {
      id: "activity",
      label: "Activity",
      kind: "select",
      options: [
        { value: "signed-in", label: "Has signed in" },
        { value: "never", label: "Never signed in" },
      ],
      placeholder: "Any",
    },
  ]
}

type UserFilterValues = Partial<Record<"role" | "activity", FilterValue>>

export function userFiltersToQuery(values: UserFilterValues): UserFilters {
  const q: UserFilters = {}
  const rawRole = values["role"]
  const role = typeof rawRole === "string" ? toRole(rawRole) : null
  if (role) q.role = role
  if (values.activity === "signed-in" || values.activity === "never") {
    q.activity = values.activity
  }
  return q
}
